import Page from '../../classes/Page';
import initContactsMap from '../../components/map';

const map = initContactsMap();

const contactsPage = new Page({
	onInit() {
		map.init()
	},
	onDestroy() {
		map.destroy()
	},
	name: 'contacts',
	rootElementId: 'js-contacts-page'
});

export default contactsPage;
